/**
 * Helper unico per risolvere il prezzo da mostrare in UI.
 *
 * Priorità:
 *   1. ``promo.priceOverride`` se presente (override Mongo, vince sempre)
 *   2. ``listino10`` (prezzo base ERP)
 *
 * Restituisce ``undefined`` se nessun prezzo è disponibile.
 */

import type { Product } from '../types';

export interface PriceInfo {
  current: string;       // "27,06"
  old?: string;          // prezzo barrato (solo con promo attiva)
  original?: string;     // alias di ``old`` (compatibilità)
  badge?: string;        // testo badge ("Flash Sale", "-25%", ecc.)
}

const fmt = (n: number): string => n.toFixed(2).replace('.', ',');

export function resolvePrice(
  _sku: string,
  listino10: number | null | undefined,
  promo?: Product['promo'],
): PriceInfo | undefined {
  if (promo?.priceOverride && promo.priceOverride > 0) {
    const current = fmt(promo.priceOverride);
    const old = listino10 != null && listino10 > promo.priceOverride
      ? fmt(listino10)
      : undefined;
    return {
      current,
      old,
      original: old,
      badge: promo.discountText || promo.label,
    };
  }
  if (listino10 != null && listino10 > 0) {
    return { current: fmt(listino10) };
  }
  return undefined;
}
